export default {
  existing_documents: {
    description: 'Masz już przesłane poniższe dokumenty. Wybierz jeden i naciśnij wyślij lub prześlij nowy dokument.',
    sides: {
      front: 'Przód',
      back: 'Tył',
    },
    created_at: 'Przesłano: {{date}}',
    expires_at: 'Wygasa: {{date}}',
  },
  document_types: {
    owner_document: 'Dokument tożsamości właściciela',
    business_document: 'Dokument firmy',
  },
  form: {
    document_type: {
      label: 'Dokument potwierdzający tożsamość',
      placeholder: 'Wybierz rodzaj dokumentu',
      options: {
        passport: 'Paszport',
        driver_license: 'Prawo jazdy',
        id_card: 'Dowód osobisty',
        residence_permit: 'Zezwolenie na pobyt',
      },
    },
    front: {
      label: 'Przód dokumentu',
    },
    back: {
      label: 'Tył dokumentu (opcjonalny dla niektórych dokumentów)',
    },
    expires_at: {
      label: 'Data ważności dokumentu',
      placeholder: 'Wybierz datę ważności',
    },
  },
  buttons: {
    select_file: 'Wybierz plik',
    next: 'Dalej',
    back: 'Tył',
    send: 'Wyślij',
    upload_new: 'Prześlij nowy dokument',
    use_existing: 'Użyj przesłanego dokumentu',
  },
};
